import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	expandAllTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseAllTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	expandAllTooltip: {
		id: 'native-issue-table.table-header-row.expand-all-button.expand-all-tooltip',
		defaultMessage: 'Expand all',
		description:
			'Tooltip for button to expand all work item hierarchies in the list/timeline views',
	},
	collapseAllTooltip: {
		id: 'native-issue-table.table-header-row.expand-all-button.collapse-all-tooltip',
		defaultMessage: 'Collapse all',
		description:
			'Tooltip for button to collapse all work item hierarchies in the list/timeline views',
	},
});
export default messages;
